export default {
  translation: {
    site_name: '桃桃漫画网',
    site_tagline: '韩国漫画无删减下拉式-免费韩漫在线阅读',
    site_description: '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。',
    nav_home: '首页',
    nav_category: '分类',
    nav_about: '关于我们',
    hero_title_line1: '韩国漫画',
    hero_title_line2: '无删减下拉式',
    hero_title_line3: '免费在线阅读',
    hero_subtitle: '可爱风格韩漫 · 每日更新 · 畅快下拉体验',
    hero_cta: '开始阅读',
    hot_series: '热门',
    hot_ongoing: '连载',
    hot_realtime: '实时更新',
    editor_picks: '编辑精选',
    editor_daily: '每日推荐',
    cta_title: '加入桃桃漫画',
    cta_subtitle: '订阅追更通知，不错过任何精彩更新',
    cta_button: '立即订阅',
    footer_subscribe_placeholder: '输入您的邮箱',
    footer_subscribe_btn: '订阅',
    footer_copyright: '© 2026 桃桃漫画网 版权所有',
    breadcrumb_home: '首页',
    read_more: '了解更多',
    start_reading: '开始阅读',
    subscribe: '订阅',
    loading: '加载中...',
    no_more: '没有更多了',
    back_to_home: '返回首页',
    page_not_found: '页面未找到',
    page_not_found_desc: '您访问的页面不存在或已被移除',
  },
};